import { availableLangs } from '@fs/zion-locale'

function findLang(code, translate) {
  const allAvailableLangs = availableLangs.core.concat(availableLangs.additional)
  const currentLang = allAvailableLangs.find((element) => element.code === code)
  if (currentLang) return currentLang.text

  return translate('common-ui:language.label', 'Language')
}

export default findLang
